const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-black via-gray-900 to-black text-gray-400 py-16 px-6">
      <div className="container mx-auto max-w-screen-xl">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Site Map */}
          <div>
            <h3 className="text-white text-lg font-semibold mb-6">PETA SITUS</h3>
            <ul className="space-y-3">
              <li>
                <a href="#" className="hover:text-white transition-colors">
                  Perjanjian Klien
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-white transition-colors">
                  Kebijakan AML
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-white transition-colors">
                  Pusat bantuan
                </a>
              </li>
            </ul>
          </div>

          {/* Empty Columns for Spacing */}
          <div className="hidden lg:block"></div>
          <div className="hidden lg:block"></div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white text-lg font-semibold mb-6">KONTAK</h3>
            <ul className="space-y-3">
              <li>
                <a href="mailto:support@stockity.id" className="hover:text-white transition-colors">
                  support@stockity.id
                </a>
              </li>
              <li className="mt-4">
                <p>Caracol Ltd.</p>
                <p className="mt-1">
                  Trust Company Complex, Ajeltake Road, Ajeltake Island, Majuro, Kepulauan Marshall, MH96960
                </p>
              </li>
              <li className="mt-4">
                <p>No.Reg. 114137</p>
              </li>
            </ul>
          </div>
        </div>

        {/* Disclaimer */}
        <div className="border-t border-gray-800 pt-8">
          <p className="text-sm leading-relaxed mb-4">
            Stockity memberikan layanan hanya kepada pengguna dewasa. Trading online dapat melibatkan risiko keuangan tinggi termasuk kehilangan semua dana di akun trading Anda. Harap pelajari semua risiko dan mintalah saran dari penasihat keuangan independen sebelum menggunakan layanan Stockity. Kami juga merekomendasikan untuk tidak menginvestasikan dana yang tidak Anda sanggup menanggungnya.
          </p>
          <p className="text-sm leading-relaxed mb-8">
            Stockity tidak bertanggung jawab untuk segala kerugian (langsung atau tidak langsung, atau konsekuensial) yang diakibatkan oleh tindakan klien di platform ini.
          </p>

          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <a href="#" className="hover:text-white transition-colors">
              Kebijakan Privasi
            </a>
            <p>&copy; 2022-2025 Stockity. All rights reserved</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
